export default __webpack_public_path__ + "static/media/bmpe.90376256.svg";